/*
    Concatenate inherited traits into a single string and add the names of the traits.
    e.g. "Beta Casein (A1A2), Beta Lactoglobulin (BB)".
 */
import {InheritedTraits} from "@/models/bullinfo";
import VueI18n from "../i18n/entry";
import { toRaw } from "vue";

export function formatInheritedTraits(values: InheritedTraits) {
    if (!values) return "";

    const rawObject = toRaw(values);

    let result = ""
    let addComma = false;

    if (rawObject.betaCaseine !== undefined && rawObject.betaCaseine !== null && rawObject.betaCaseine.trim() !== "") {
        result += `${VueI18n.global.t('details.summary.first.betaCasein')} (${rawObject.betaCaseine})`;
        addComma = true;
    }
    if (rawObject.kappaCaseine !== undefined && rawObject.kappaCaseine !== null && rawObject.kappaCaseine.trim() !== "") {
        if (addComma) {
            result += ", ";
        }
        result += `${VueI18n.global.t('details.summary.first.kappaCasein')} (${rawObject.kappaCaseine})`;
        addComma = true;
    }
    if (rawObject.betaLactoglobuline !== undefined && rawObject.betaLactoglobuline !== null && rawObject.betaLactoglobuline.trim() !== "") {
        if (addComma) {
            result += ", ";
        }
        result += `${VueI18n.global.t('details.summary.first.betaLactoglobulin')} (${rawObject.betaLactoglobuline})`;
    }

    return result;
}